import { Warning } from '@phosphor-icons/react';

import { useEnvStore } from '@/lib/store/envStore';

export function LiveEnvBanner() {
    const env = useEnvStore((state) => state.env);
    if (env !== 'live') return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="sticky top-0 z-40 flex h-7 items-center justify-center gap-2 border-b border-destructive/40 bg-destructive/10 px-3 text-2xs font-medium text-destructive"
        >
            <Warning weight="fill" className="h-3 w-3 shrink-0" aria-hidden />
            <span>
                Live environment — actions affect production data and real money.
            </span>
        </div>
    );
}
